const en = {
  // Header / Navigation
  'nav.sports': 'Sports Betting',
  'nav.live': 'Live Betting',
  'nav.games': 'Games',
  'nav.promotions': 'Promotions',
  'nav.deposit': 'Deposit',
  'nav.myBets': 'My Bets',
  'nav.news': 'News',
  'nav.account': 'Account',
  'nav.login': 'Login',
  'nav.register': 'Register',
  'nav.logout': 'Logout',

  // Login
  'login.welcome': 'Welcome',
  'login.noAccount': 'Do not have an account?',
  'login.registerNow': 'Register now',
  'login.requiredFields': 'Fields marked with * are required.',
  'login.emailUsername': '* Email / Username',
  'login.password': '* Password',
  'login.hidePassword': 'Hide password',
  'login.showPassword': 'Show password',
  'login.rememberMe': 'Remember me',
  'login.loginButton': 'Login',
  'login.pleaseWait': 'Please wait...',
  'login.forgotPassword': 'Forgot password?',
  'login.shopCustomer': 'Are you a shop customer?',
  'login.activateOnlineAccount': 'Activate online account',
  'login.failed': 'Login failed',
  'login.invalidCredentials': 'Invalid credentials',

  // Sidebar
  'sidebar.search': 'Team, Event or Competition',
  'sidebar.quickAccess': 'Quick Access',
  'sidebar.topEvents': 'Top Events',
  'sidebar.topKombis': 'Top Combos',
  'sidebar.todayMatches': "Today's Matches",
  'sidebar.germanFootball': 'German Football',
  'sidebar.europeanFootball': 'European Football',
  'sidebar.topCompetitions': 'Top Competitions',
  'sidebar.topSports': 'Top Sports',
  'sidebar.allSports': 'All Sports',
  'sidebar.showAllCategories': 'Show all categories',
  'sidebar.hideCategories': 'Hide categories',

  // Sports
  'sport.football': 'Football',
  'sport.tennis': 'Tennis',
  'sport.basketball': 'Basketball',
  'sport.iceHockey': 'Ice Hockey',
  'sport.handball': 'Handball',
  'sport.baseball': 'Baseball',
  'sport.americanFootball': 'American Football',
  'sport.boxing': 'Boxing',
  'sport.cricket': 'Cricket',
  'sport.darts': 'Darts',
  'sport.rugby': 'Rugby',
  'sport.tableTennis': 'Table Tennis',
  'sport.beachVolleyball': 'Beach Volleyball',
  'sport.esports': 'E-Sports',

  // Market Types
  'market.tip': 'Result',
  'market.tipRemainingTime': 'Remaining Time',
  'market.firstHalf': '1st Half',
  'market.overUnder': 'Over/Under',
  'market.doubleChance': 'Double Chance',
  'market.bothTeamsScore': 'Both Teams to Score',

  // Bet Outcomes
  'outcome.fhHomeWinRemainingTime': '1st Half Home Win Rem.',
  'outcome.fhDrawRemainingTime': '1st Half Draw Rem.',
  'outcome.fhAwayWinRemainingTime': '1st Half Away Win Rem.',
  'outcome.fhNextGoalHome': '1st Half Next Goal Home',
  'outcome.fhNextGoalAway': '1st Half Next Goal Away',
  'outcome.nextGoalHome': 'Next Goal Home',
  'outcome.nextGoalAway': 'Next Goal Away',
  'market.nextGoal': 'Next Goal',
  'outcome.home': 'Home',
  'outcome.away': 'Away',
  'outcome.homeWin': 'Home Win',
  'outcome.draw': 'Draw',
  'outcome.awayWin': 'Away Win',
  'outcome.over': 'Over',
  'outcome.under': 'Under',
  'outcome.yes': 'Yes',
  'outcome.no': 'No',
  'outcome.fhHomeWin': '1H Home Win',
  'outcome.fhDraw': '1H Draw',
  'outcome.fhAwayWin': '1H Away Win',
  'outcome.fhOver': '1H Over',
  'outcome.fhUnder': '1H Under',
  'outcome.homeWinRemainingTime': 'Home Win (Rem.)',
  'outcome.drawRemainingTime': 'Draw (Rem.)',
  'outcome.awayWinRemainingTime': 'Away Win (Rem.)',

  // Section Titles
  'section.nextGames': 'Next Games',
  'section.topEvents': 'Top Events',
  'section.lastMinute': 'Last Minute',
  'section.live': 'Live',
  'section.next6Hours': 'Next 6 Hours',
  'section.topKombis': 'Top Combos',
  'section.topKombisSubtitle': 'from other customers',
  'section.showAll': 'Show all',
  'section.createMkPlus': 'Create MK+',
  'section.viewAll': 'All',

  // Betting Slip
  'slip.title': 'Bet Slip',
  'slip.empty': 'Your bet slip is empty.',
  'slip.emptyHint': 'Select your bets now.',
  'slip.single': 'Single',
  'slip.combi': 'Combo',
  'slip.system': 'System',
  'slip.stake': 'Stake',
  'slip.totalStake': 'Total Stake',
  'slip.setStake': 'Set Stake',
  'slip.totalOdds': 'Total Odds',
  'slip.potentialWin': 'Potential Win',
  'slip.placeBet': 'Place Bet',
  'slip.openBets': 'Open Bets',
  'slip.viewTicket': 'View Ticket',
  'slip.noOpenBets': 'You have no open bets.',
  'slip.combiBet': 'Combo Bet',
  'slip.singleBet': 'Single Bet',
  'slip.singleBets': 'Single Bets',
  'slip.potentialWinShort': 'Pot. Win',
  'slip.maxWin': 'Max. Win',
  'slip.requestCashout': 'Request Cashout',
  'slip.combinations': 'Combinations (Ways)',
  'slip.cashoutValue': 'Cashout Value',
  'slip.confirmCashout': 'Confirm Cashout',
  'slip.errorRequestingQuote': 'Error requesting quote.',
  'slip.cashoutFailed': 'Cashout failed.',
  'slip.error.payoutLimitExceeded': 'Maximum payout limit exceeded. Please reduce your stake.',
  'slip.errorPlacingBet': 'Error placing bet.',
  'slip.placementScore': 'Placement:',
  'slip.currentScore': 'Current:',
  'slip.placingBet': 'Creating ticket...',
  'slip.placingWait': 'Please wait, processing...',
  'slip.placingBtn': 'Placing...',
  'slip.betSuccess': 'Ticket Approved',
  'slip.betSuccessDesc': 'Your bet has been successfully placed!',
  'slip.hasLockedBets': 'Your slip contains locked/suspended bets.',

  // Live
  'live.noEvents': 'No live events for',
  'live.games': 'Games',
  'live.sortBy': 'Sort by:',
  'live.time': 'Time',
  'live.competition': 'Competition',
  'live.halfTime': '1st Half',
  'live.ht': 'HT',
  'live.ft': 'FT',

  // Time
  'time.today': 'Today',
  'time.tomorrow': 'Tomorrow',
  'time.minutes': 'Min',
  'time.hoursShort': 'Hrs',

  // Top Kombis Card
  'kombis.betsPlaced': 'Bets placed',
  'kombis.combi': 'Combo',
  'kombis.totalOdds': 'Total Odds',
  'kombis.tip': 'Pick',

  // Account
  'account.myAccount': 'My Account',
  'account.loginPrompt': 'Please log in to manage your account.',
  'account.verification': 'Account Verification',
  'account.management': 'Account Management & Limits',
  'account.transactions': 'Transactions',
  'account.personalData': 'Personal Data',
  'account.responsibleGaming': 'Responsible Gaming',
  'account.meineDaten': 'My Data',
  'account.kontoverifizierung': 'Account Verification',
  'account.kontoverwaltung': 'Account Management & Limits',
  'account.transaktionsverlauf': 'Transaction History',
  'account.guthaben': 'Balance',
  'account.auszahlung': 'Withdrawal',
  'account.einstellungen': 'Settings',
  'account.neuigkeiten': 'News',
  'account.apps': 'Tipico Apps',
  'account.kontakt': 'Contact',
  'account.abmelden': 'Logout & Deactivate',
  'account.userTabs.personal': 'User Data',
  'account.userTabs.contact': 'Contact Details',
  'account.userTabs.password': 'Change Password',
  'account.fields.name': 'First and Last Name:',
  'account.fields.username': 'Username:',
  'account.fields.birthname': 'Birth Name:',
  'account.fields.birthdate': 'Date of Birth:',
  'account.fields.email': 'Email:',
  'account.fields.emailChange': 'Change Email',
  'account.fields.lugasId': 'Lugas Player ID:',
  'account.mockUpdateSuccess': 'Successfully updated',
  'account.fields.address': 'Address',
  'account.fields.city': 'City',
  'account.fields.zip': 'ZIP Code',
  'account.fields.phone': 'Phone Number',
  'account.fields.currentPassword': 'Current Password',
  'account.fields.newPassword': 'New Password',
  'account.fields.confirmPassword': 'Confirm New Password',
  'account.saveChanges': 'Save Changes',
  'account.underConstruction': 'This area is still under construction.',
  'account.supportPlaceholder': 'Please describe your request as accurately as possible...',
  'account.salutationMr': 'Mr.',
  'account.loginBtn': 'Login',
  'account.transactions.title': 'Transaction History',
  'account.transactions.type': 'Type',
  'account.transactions.amount': 'Amount',
  'account.transactions.status': 'Status',
  'account.transactions.date': 'Date',
  'account.transactions.id': 'Reference ID',
  'account.transactions.noTransactions': 'No transactions found.',
  'account.transactions.deposit': 'Deposit',
  'account.transactions.withdrawal': 'Withdrawal',
  'account.transactions.status.completed': 'Successful',
  'account.transactions.status.pending': 'Pending',
  'account.transactions.status.failed': 'Failed',
  'account.transactions.filter.all': 'All',
  'account.transactions.filter.startDate': 'From:',
  'account.transactions.filter.endDate': 'To:',
  'account.transactions.filter.reset': 'Reset',
  'account.balance.title': 'Balance & Wallet',
  'account.balance.total': 'Total Balance',
  'account.balance.available': 'Available',
  'account.balance.locked': 'Locked',
  'account.balance.realCash': 'Real Cash',
  'account.balance.bonusCash': 'Bonus Balance',
  'account.balance.premiumWallet': 'Tipico Premium Wallet',
  'account.balance.depositAction': 'Deposit Funds',
  'account.balance.withdrawAction': 'Withdraw Funds',
  'account.balance.recentActivity': 'Recent Activity',
  'account.balance.viewAllTransactions': 'View all transactions',
  'account.notifications.title': 'News & Notifications',
  'account.notifications.empty': 'No notifications available.',
  'account.notifications.markAllRead': 'Mark all as read',
  'account.notifications.markRead': 'Mark as read',
  'account.notifications.viewAll': 'View all',
  'account.withdrawal.title': 'Initiate Withdrawal',
  'account.withdrawal.selectMethod': 'Select Withdrawal Method:',
  'account.withdrawal.amount': 'Withdrawal Amount',
  'account.withdrawal.enterAmount': 'Enter amount',
  'account.withdrawal.availableToWithdraw': 'Available cash balance:',
  'account.withdrawal.submit': 'Request Withdrawal',
  'account.withdrawal.processingTime': 'Duration',
  'account.withdrawal.instant': 'Instant',
  'account.withdrawal.bankDays': '1-3 business days',
  'account.withdrawal.successMessage': 'Your withdrawal request has been successfully submitted!',
  'account.withdrawal.successSub': 'The amount will be credited to your chosen payment method shortly.',
  'account.withdrawal.refId': 'Reference ID:',
  'account.withdrawal.error.insufficient': 'Insufficient cash balance.',
  'account.withdrawal.error.minimum': 'The minimum withdrawal amount is 10 €.',
  'account.withdrawal.backToWallet': 'Back to Balance',

  // Login/Register
  'auth.loginTitle': 'Login',
  'auth.registerTitle': 'Register',
  'auth.email': 'Email',
  'auth.username': 'Username',
  'auth.password': 'Password',
  'auth.confirmPassword': 'Confirm Password',
  'auth.noAccount': "Don't have an account?",
  'auth.hasAccount': 'Already have an account?',
  'auth.welcomeTitle': 'Dive into the world of sports betting!',
  'auth.bonusTitle': 'Double your first deposit',
  'auth.bonusSubtitle': 'up to €100',
  'auth.registrationOnlyGermany': 'Registration is only available from Germany.',

  // My Bets
  'bets.myBets': 'My Bets',
  'bets.active': 'Active',
  'bets.settled': 'Settled',
  'bets.won': 'Won',
  'bets.lost': 'Lost',
  'bets.pending': 'Pending',

  // Misc
  'match.mainBets': 'Main Bets',
  'match.allBets': 'All Bets',
  'match.allMarkets': 'All Markets',
  'match.betBuilderPlus': 'Bet Builder+',
  'misc.noOdds': 'No odds',
  'misc.matches': 'Matches',
  'misc.matchKombi': 'MatchCombo+',
  'misc.outrights': 'Outrights',
  'misc.statistics': 'Statistics',
  'misc.search': 'Search',
  'misc.close': 'Close',
  'misc.back': 'Back',
  'misc.events': 'Events',
  'misc.topCompetitions': 'Top Competitions',
  'misc.noMatches': 'No matches found to display.',
  'misc.loading': 'Loading…',
  'misc.confirmColon': 'Confirm:',
  'misc.confirm': 'Confirm',
  'misc.cancel': 'Cancel',
  'misc.error': 'Error.',
};

export default en;
